import axios from 'axios';
import {
  ILegal,
  ILegalCollection,
  ILegalListParams,
  ICreateLegalPayload,
  IDeleteLegalPayload,
  IUpdateLegalPayload,
  IUpdateBySellerLegalPayload,
} from 'entities/LegalEntity/LegalEntity.models';

const basePath = 'legal';

export const legalEntityTransport = {
  get: (params: ILegalListParams): Promise<ILegalCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<ILegal> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateLegalPayload): Promise<ILegal> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateLegalPayload): Promise<ILegal> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteLegalPayload): Promise<ILegal> => axios.delete(`${basePath}`, { data: payload }),
  updateBySeller: (payload: IUpdateBySellerLegalPayload): Promise<ILegal> => axios.patch(`${basePath}/by-seller`, payload),
};
